// extracted by mini-css-extract-plugin
module.exports = {"base":"Drawer_base__2gHwY","innerBase":"Drawer_innerBase__2VtO5","palet":"Drawer_palet__15l86"};